import { createSlice } from '@reduxjs/toolkit'
import { createSelector } from 'reselect'


const slice = createSlice({
  name: 'booking_verification',
  initialState: {
    selectedEventTypes: {},
    selectedEventTypeIds: {}
  },
  reducers: {
    setSelectedEventTypes: (state, { payload }) => {
      if (state.selectedEventTypes[payload.uuid]) {
        delete state.selectedEventTypes[payload.uuid]
        delete state.selectedEventTypeIds[payload.id]
      } else {
        state.selectedEventTypes[payload.uuid] = true
        state.selectedEventTypeIds[payload.id] = true
      }
    },
    resetSelectedEventTypes: (state) => {
      state.selectedEventTypes = {}
      state.selectedEventTypeIds = {}
    }
  }
})

export const {
  reducer,
  actions: {
    setSelectedEventTypes,
    resetSelectedEventTypes
  }
} = slice

const rootSelector = (state) => state.bookingVerification

export const selectedEventTypesSelector = createSelector(rootSelector, ({ selectedEventTypes }) => selectedEventTypes)
export const selectedEventTypeIdsSelector = createSelector(rootSelector, ({ selectedEventTypeIds }) => selectedEventTypeIds)
